import { useState, useEffect } from "react";
import { Modal, Form } from "react-bootstrap";
import formatError from "../../services/FormatError";
import {
  addContractType,
  fetchContractTypeDetails,
} from "../../services/ContractTypes";
import { t } from "i18next";


function AddContractTypes({ show, id, fetchContractTypes, onHide }) {
  const [name, setName] = useState("");

  const [addTriggered, setAddTriggered] = useState(false);

  useEffect(() => {
    if (id !== null) {
      fetchCTDetails();
    }
  }, [id]);

  const fetchCTDetails = () => {
    fetchContractTypeDetails(id)
      .then((res) => {
        setName(res.data?.result?.name);
      })
      .catch((error) => {
        formatError(error.response?.data?.error);
      });
  };

  const onAddContractType = (e) => {
    e.preventDefault();

    if (name !== "") {
      addContractType(name, id)
        .then((res) => {
          setName("");

          setAddTriggered(false);

          onHide();

          fetchContractTypes();
        })
        .catch((error) => {
          formatError(error.response?.data?.error);
        });
    } else {
      setAddTriggered(true);
    }
  };

  return (
    <Modal className="modal fade" show={show} onHide={onHide}>
      <div role="document">
        <div>
          <Form>
            <div className="modal-header">
              <h4 className="modal-title fs-20">
                {id === null ? t("globalAddButton") : t("globalUpdateButton")} {t("sidebarItemContractTypes")}
              </h4>
              <button type="button" className="close btn" onClick={onHide}>
                <span>×</span>
              </button>
            </div>

            <div className="modal-body">
              <i className="flaticon-cancel-12 close" data-dismiss="modal"></i>

              <div className="add-contact-box">
                <div className="add-contact-content">
                  <div
                    className={`form-group ${
                      addTriggered && name === "" ? "" : "mb-3"
                    }`}
                  >
                    <label className="mb-1">
                      <span className="text-danger">*</span>
                      &ensp;
                      <strong>{t("nameInput")}</strong>
                    </label>
                    <input
                      type="text"
                      placeholder="Name"
                      className="form-control"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                    />
                  </div>
                  {addTriggered && name === "" && (
                    <div className="text-danger fs-12">{t("hrequiredName")}</div>
                  )}
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn"
                style={{ background: "#808080", color: "#fff" }}
                onClick={onHide}
              >
                <i className="flaticon-delete-1"></i>
                &nbsp;{t("discard")}
              </button>
              {id === null ? (
                <button
                  type="submit"
                  className="btn btn-primary"
                  onClick={onAddContractType}
                >
                  {t("add")}
                </button>
              ) : (
                <button
                  type="submit"
                  className="btn btn-primary"
                  onClick={onAddContractType}
                >
                  {t("globalUpdateButton")}
                </button>
              )}
            </div>
          </Form>
        </div>
      </div>
    </Modal>
  );
}

export default AddContractTypes;
